export default "__VITE_PUBLIC_ASSET__a487b917__"